import { PointsForQuestions } from "./types";

export const QUESTIONS_PER_ROUND = 6;

export const POINTS_FOR_QUESTIONS: PointsForQuestions = {
  0: 0,
  1: 1,
  2: 3,
  3: 5,
  4: 10,
  5: 15,
  6: 20,
};
